import { apiRequest } from "./api";
import useAuthToken from "../../Hooks/useAuthToken";

export const loginApi = async (credentials) => {
  if (!credentials.email || !credentials.password) {
    throw new Error("Please provide both Email and Password");
  }
  return apiRequest("post", "/api/user/signin", credentials);
};

export const registerApi = async (credentials) => {
  return apiRequest("post", "/api/user/create", credentials);
};

export const useRegister = () => {
  const token = useAuthToken();
  const createRegister = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/user/create", credentials, token);
  };

  return createRegister;
};

export const useGetUser = () => {
  const token = useAuthToken();
  const getUser = async () => {
    return apiRequest("get", "/api/user/", null, token);
  };

  return getUser;
};

export const logOutApi = async (credentials) => {
  const token = credentials.token;
  const data = {
    clientloginToken: credentials.clientloginToken,
    tokenExpiration: credentials.tokenExpiration,
  };
  return apiRequest(
    "patch",
    `/api/client/${credentials.Clientid}`,
    data,
    token
  );
};

export const useUpdateUser = (id) => {
  const token = useAuthToken();

  const updateUser = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/user/${id}`,
      formData,
      token
    );

    return response;
  };

  return updateUser;
};
